import { useTranslation } from "react-i18next";
import { RiNotificationOffLine } from "react-icons/ri";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  getNotifications,
  readNotification,
  getNotificationsCount,
  setShowNotification,
} from "../../actions/notification";
import { getNotificationParams } from "./helper";
import NotificationCard from "./NotificationCard";
import { successReadNotificationToast } from "../../actions/bcfData";
import { RootState } from "@Reducers/index";

function Notification(props: any) {
  const { t } = useTranslation();
  const showNotification = useSelector((state: RootState) => state.showNotification);
  const dispatch = useDispatch();

  const [fetchedData, setFetchedData] = useState<any>({});
  const [newNotifications, setNewNotifications] = useState<any[]>([]);
  const [previousNotifications, setPreviousNotifications] = useState<any[]>([]);
  const notificationStatus = useRef(showNotification);

  const handleClick = (e: any) => {
    if (!e.target.closest(".preventNotificationClose") && notificationStatus.current) {
      closeNotificationModal();
    }
  };

  const closeNotificationModal = () => {
    dispatch(setShowNotification(false));
  };

  const dismissNotification = async (id: any) => {
    const response = await readNotification([id]);
    if (response) {
      const countPreviousNotificationsRequired = Math.max(
        previousNotifications.length >= 4 && previousNotifications.length <= 7
          ? previousNotifications.length + 1
          : previousNotifications.length,
        2,
      );
      const fetchedNotificationsData = await getNotifications(5, countPreviousNotificationsRequired);
      setFetchedData(fetchedNotificationsData);
      dispatch(getNotificationsCount({ read: "NOTIFICATION_UNREAD" }));
      dispatch(successReadNotificationToast([id]));
    }
  };

  const handleNotifications = async () => {
    if (showNotification) {
      const countPreviousNotificationsRequired = Math.max(previousNotifications.length, 2);
      const fetchedNotificationsData = await getNotifications(5, countPreviousNotificationsRequired);
      setFetchedData(fetchedNotificationsData);
    }
  };

  useEffect(() => {
    handleNotifications();
  }, [showNotification]);

  useEffect(() => {
    notificationStatus.current = showNotification;
  }, [showNotification]);

  useEffect(() => {
    window.addEventListener("click", handleClick);
    return () => {
      window.removeEventListener("click", handleClick);
    };
  }, []);

  useEffect(() => {
    const newNotificationsData = fetchedData.new;
    const previousNotificationsData = fetchedData.previous;

    if (newNotificationsData) {
      const newData = newNotificationsData.result.map((notification: any) => getNotificationParams(notification));
      setNewNotifications(newData);
    }

    if (previousNotificationsData) {
      const oldData = previousNotificationsData.result.map((notification: any) => getNotificationParams(notification));
      setPreviousNotifications(oldData);
    }
  }, [fetchedData]);

  useEffect(() => {
    dispatch(getNotificationsCount({ read: "NOTIFICATION_UNREAD" }));
  }, []);

  return (
    <>
      {showNotification && (
        <div className="shadow-[0_40px_40px_rgba(106,168,177,0.2)] top-14 end-20 bg-white absolute max-h-[80vh] w-2/5 z-30 border border-[#ecf3fe] overflow-y-auto rounded-2xl preventNotificationClose">
          {showNotification && newNotifications.length > 0 && (
            <div className="flex w-full flex-col">
              <NotificationCard
                closeNotificationModal={closeNotificationModal}
                title={t("New")}
                notificationsList={newNotifications}
                dismissNotification={dismissNotification}
                {...props}
              />
            </div>
          )}

          {showNotification && previousNotifications.length > 0 && (
            <div className="flex w-full flex-col">
              <NotificationCard
                closeNotificationModal={closeNotificationModal}
                title={t("Earlier")}
                notificationsList={previousNotifications}
                dismissNotification={dismissNotification}
                {...props}
              />
            </div>
          )}

          {showNotification && newNotifications.length === 0 && previousNotifications.length === 0 && (
            <div className="flex flex-col items-center justify-center">
              <RiNotificationOffLine className="m-auto h-[6.25rem] w-[6.25rem] fill-[#a9dff9]" />
              <p className="mt-2.5 text-center">{t("No Notifications right now!")}</p>
            </div>
          )}
          <div className="sticky bottom-0 bg-white px-8 py-4 text-center">
            <Link to="/notifications?section=allNotifications" className="text-base font-bold text-[#6bbbe3]">
              <span onClick={closeNotificationModal}>{t("View All Notifications")}</span>
            </Link>
          </div>
        </div>
      )}
    </>
  );
}

export default Notification;
